/* eslint-disable max-lines */
import { DEFAULT_CATEGORY_VALUE, DEFAULT_COMPANY_ID, EMPTY_STRING, INTERVIEW_STATUS, INTERVIEW_TABS } from '@constants';
import dayjs from 'dayjs';

export const selectInterviewDefaultValues = {
  onlyUncompleted: String(INTERVIEW_STATUS.ALL),
  assignedToMe: false,
};

export const filterProjectDefaultValues = {
  companyId: DEFAULT_COMPANY_ID,
};

export const commentsDefaultValues = {
  text: '',
  category: DEFAULT_CATEGORY_VALUE,
};

export const RELATIVE_PRICES_RANGE = {
  MIN: 1,
  MAX: 80,
};

export const DEFAULT_PERCANTAGE_VALUE = 50;
export const DEFAULT_RELATIVE_PRICE = 5;

export const RELATIVE_PRICES_OPTIONS = ['higher', 'the same', 'lower', ''];

export const NO_VALUE_RESPONSE = -999;

export const SCALED_SLIDER_MAX_VALUE = 10;
export const SCALED_SLIDER_MIN_VALUE = 1;
export const SCALED_SLIDER_MIN_WIDTH = 368;
export const SCALED_SLIDER_DEFAULT_VALUE = 5;
export const SCALED_SLIDER_MAX_LENGTH = 200;

export const SUPPLIER_MAX_LENGTH = 28;

export const SWITCH_HIEGHT = 38;

export const SCALED_SLIDER_MARKS = [
  { value: 1, label: '1' },
  { value: 1.5, label: '' },
  { value: 2, label: '2' },
  { value: 2.5, label: '' },
  { value: 3, label: '3' },
  { value: 3.5, label: '' },
  { value: 4, label: '4' },
  { value: 4.5, label: '' },
  { value: 5, label: '5' },
  { value: 5.5, label: '' },
  { value: 6, label: '6' },
  { value: 6.5, label: '' },
  { value: 7, label: '7' },
  { value: 7.5, label: '' },
  { value: 8, label: '8' },
  { value: 8.5, label: '' },
  { value: 9, label: '9' },
  { value: 9.5, label: '' },
  { value: 10, label: '10' },
];

export const PRICES_SENSITIVITY_RANGE = {
  MIN: 1,
  MAX: 99,
};

export enum CLOSE_QUESTION_VALUES {
  NO,
  YES,
}

export const CLOSE_QUESTION_OPTIONS = [
  { i18nKey: 'interview.generalQuestions.yes', key: 'CvaInput.Yes', value: CLOSE_QUESTION_VALUES.YES },
  { i18nKey: 'interview.generalQuestions.no', key: 'CvaInput.No', value: CLOSE_QUESTION_VALUES.NO },
];

export const GENERAL_QUESTIONS_MAX_LENGTH = 500;

export const BUSINESS_COMPETITORS_RANGE = {
  MIN: 1,
  MAX: 10,
};

export const BLANK_COMPETITORS_RANGE = {
  MIN: 2,
  MAX: 10,
};

export enum QUESTION_TYPES {
  OPEN = 'OPEN',
  CLOSE = 'CLOSE',
  NUMERICAL = 'NUMERICAL',
  MULTIPART = 'MULTIPART',
}

export const ATTRIBUTE_SUPPLIERS_MINIMUM = 2;

export const THIS_BUSINESS_LABEL_LENGTH = 6;
export const SUPPLIER_LABEL_LENGTH = 10;
export const WRAP_WORDS_LENGTH = 15;

export const REVIEW_FORMS: number[] = [
  INTERVIEW_TABS.SUPPLIERS,
  INTERVIEW_TABS.RELATIVE_PRICES,
  INTERVIEW_TABS.PRICE_SENSITIVITY,
  INTERVIEW_TABS.GENERAL_QUESTIONS,
  INTERVIEW_TABS.ATTRIBUTE_PERFORMANCE,
];

export const INTERVIEW_FORMS: number[] = [
  INTERVIEW_TABS.SUPPLIERS,
  INTERVIEW_TABS.RELATIVE_PRICES,
  INTERVIEW_TABS.PRICE_SENSITIVITY,
  INTERVIEW_TABS.ATTRIBUTE_IMPORTANCE,
  INTERVIEW_TABS.PRODUCT_SCORES,
  INTERVIEW_TABS.SERVICE_SCORES,
  INTERVIEW_TABS.IMAGE_SCORES,
  INTERVIEW_TABS.GENERAL_QUESTIONS,
];

export const VALIDATION_ERRORS = {
  SUPPLIERS_MIN: 'suppliersMin',
  SUPPLIER_NAME: 'supplierName',
  SUPPLIER_UNIQUE_NAME: 'suppliersUniqueName',
  PRICE_RANGE: 'priceRange',
  EMPTY_SUPPLIER_NAME: 'emptySupplierName',
  UNSET_PRICE_TYPE: 'unsetPriceType',
  PRICE_WEIGHT: 'priceWeight',
  IMPORTANCE_RANGE: 'importanceRange',
};

export const ATTRIBUTE_DESCRIPTION_MAX_LENGTH = 200;

export const NAME_LENGTH_RANGE = {
  MIN: 3,
  MAX: 100,
};

export enum PROJECT_CREATION_NAMES {
  PROJECT = 'PROJECT',
  BUSINESS = 'BUSINESS',
}

export const PASSWORD_MIN_LENGTH = 6;

export const addAgregationDefaultValues = {
  name: EMPTY_STRING,
  year: dayjs().year(),
  category: EMPTY_STRING,
  worksheetIds: [],
  aggregatedSegments: [],
};

export const IMPORT_INTERVIEWEE_ALLOWED_TYPES = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
];
